/* eslint-disable max-len */
import { LinkedReference } from '@1po/1po-bff-fe-spec/generated/catalog/references/dh/model/Reference';
import { ReferenceDiscount } from '@1po/1po-bff-fe-spec/generated/catalog/trading_data/model/ReferenceDiscount';
import { ReferenceStock } from '@1po/1po-bff-fe-spec/generated/catalog/trading_data/model/ReferenceStock';
import { Reference } from '@1po/1po-bff-fe-spec/generated/estimate/request/model/Reference';
import { MyStoreBundle } from '@1po/1po-bff-fe-spec/generated/estimate/response/AutocompleteSearchBundlesResponse';
import { MyStoreReference } from '@1po/1po-bff-fe-spec/generated/estimate/response/AutocompleteSearchReferencesResponse';
import { EstimateDmsOrderNumbers } from '@1po/1po-bff-fe-spec/generated/estimate/response/EstimateDmsOrderNumbers';
import {
  BundleOrRecyclingSection,
  ClientContact,
  LaborTimeSection,
  ReferenceSection,
  TotalPrice,
  Vehicle,
  OperationSection,
} from '@1po/1po-bff-fe-spec/generated/estimate/response/GetEstimate';
import { HistoryEstimate } from '@1po/1po-bff-fe-spec/generated/estimate/response/GetEstimateHistory';
import { Settings } from '@1po/1po-bff-fe-spec/generated/estimate/response/GetSettings';
import { OrderMKTPDeliveryMode } from '@1po/1po-bff-fe-spec/generated/order/request/CheckoutOrderRequest';
import { APP_NAMESPACE } from 'app/App.constants';
import { ReferencePriceType } from 'domains/references';
import { NO_DATA, PROGRESS_STATUS, SEARCH_STATUS, SearchData } from 'utils';

export const ESTIMATE_NAMESPACE = `${APP_NAMESPACE}/ESTIMATE`;

export const GET_ESTIMATE_BY_ID = `${ESTIMATE_NAMESPACE}/GET_BY_ID`;
export const ADD_CATALOG_LABOR_TIME = `${ESTIMATE_NAMESPACE}/ADD_CATALOG_LABOR_TIME`;
export const ADD_CATALOG_REFERENCE = `${ESTIMATE_NAMESPACE}/ADD_CATALOG_REFERENCE`;
export const ADD_CATALOG_TIRE = `${ESTIMATE_NAMESPACE}/ADD_CATALOG_TIRE`;
export const ADD_CUSTOM_REFERENCE = `${ESTIMATE_NAMESPACE}/ADD_CUSTOM_REFERENCE`;
export const ADD_CUSTOM_OPERATION_REFERENCE = `${ESTIMATE_NAMESPACE}/ADD_CUSTOM_OPERATION_REFERENCE`;
export const ADD_OPERATION = `${ESTIMATE_NAMESPACE}/ADD_OPERATION`;
export const ADD_EASYBASKET_OPERATION_TO_ESTIMATE = `${ESTIMATE_NAMESPACE}/ADD_EASYBASKET_OPERATION_TO_ESTIMATE`;
export const ADD_CUSTOM_TIRE = `${ESTIMATE_NAMESPACE}/ADD_CUSTOM_TIRE`;
export const ADD_CUSTOM_LABOR_TIME = `${ESTIMATE_NAMESPACE}/ADD_CUSTOM_LABOR_TIME`;
export const ADD_CUSTOM_OPERATIONLABOR_TIME = `${ESTIMATE_NAMESPACE}/ADD_CUSTOM_OPERATIONLABOR_TIME`;
export const ADD_CUSTOM_BUNDLE_OR_RECYCLING = `${ESTIMATE_NAMESPACE}/ADD_CUSTOM_BUNDLE_OR_RECYCLING`;
export const ADD_OTHER_ITEM = `${ESTIMATE_NAMESPACE}/ADD_OTHER_ITEM`;
export const ADD_CATALOG_REFERENCE_BY_REFERENCE_NUMBER = `${ESTIMATE_NAMESPACE}/ADD_CATALOG_REFERENCE_BY_REFERENCE_NUMBER`;
export const ADD_CATALOG_TIRE_BY_REFERENCE_NUMBER = `${ESTIMATE_NAMESPACE}/ADD_CATALOG_TIRE_BY_REFERENCE_NUMBER`;
export const ADD_BUNDLES_FROM_MY_STORE = `${ESTIMATE_NAMESPACE}/ADD_BUNDLES_FROM_MY_STORE`;
export const ADD_BUNDLES_FROM_AUTOCOMPLETE = `${ESTIMATE_NAMESPACE}/ADD_BUNDLES_FROM_AUTOCOMPLETE`;
export const ADD_REFERENCE_NUMBER = `${ESTIMATE_NAMESPACE}/ADD_REFERENCE_NUMBER`;
export const ADD_CATALOG_LABOR_TIME_BY_CODE = `${ESTIMATE_NAMESPACE}/ADD_CATALOG_LABOR_TIME_BY_CODE`;
export const ADD_REFERENCE_FROM_AUTOCOMPLETE = `${ESTIMATE_NAMESPACE}/ADD_REFERENCE_FROM_AUTOCOMPLETE`;

export const UPDATE_REFERENCE = `${ESTIMATE_NAMESPACE}/UPDATE_REFERENCE`;
export const UPDATE_OPERATION_REFERENCE = `${ESTIMATE_NAMESPACE}/UPDATE_OPERATION_REFERENCE`;
export const UPDATE_LABOR_TIME = `${ESTIMATE_NAMESPACE}/UPDATE_LABOR_TIME`;
export const UPDATE_OPERATION_LABOR_TIME = `${ESTIMATE_NAMESPACE}/UPDATE_OPERATION_LABOR_TIME`;
export const UPDATE_BUNDLE_OR_RECYCLING = `${ESTIMATE_NAMESPACE}/UPDATE_BUNDLE_OR_RECYCLING`;
export const UPDATE_OPERATION = `${ESTIMATE_NAMESPACE}/UPDATE_OPERATION`;
export const ADD_VEHICLE = `${ESTIMATE_NAMESPACE}/ADD_VEHICLE`;
export const UPDATE_VEHICLE = `${ESTIMATE_NAMESPACE}/UPDATE_VEHICLE`;
export const UPDATE_CLIENT = `${ESTIMATE_NAMESPACE}/UPDATE_CLIENT`;
export const UPDATE_OBSERVATIONS = `${ESTIMATE_NAMESPACE}/UPDATE_OBSERVATIONS`;

export const REMOVE_REFERENCE = `${ESTIMATE_NAMESPACE}/REMOVE_REFERENCE`;
export const REMOVE_OPERATION_REFERENCE = `${ESTIMATE_NAMESPACE}/REMOVE_OPERATION_REFERENCE`;
export const REMOVE_TIRE = `${ESTIMATE_NAMESPACE}/REMOVE_TIRE`;
export const REMOVE_LABOR_TIME = `${ESTIMATE_NAMESPACE}/REMOVE_LABOR_TIME`;
export const REMOVE_OPERATION_LABOR_TIME = `${ESTIMATE_NAMESPACE}/REMOVE_OPERATION_LABOR_TIME`;
export const REMOVE_OTHER_ITEM = `${ESTIMATE_NAMESPACE}/REMOVE_OTHER_ITEM`;
export const REMOVE_BUNDLE_OR_RECYCLING = `${ESTIMATE_NAMESPACE}/REMOVE_BUNDLE_OR_RECYCLING`;
export const REMOVE_OPERATION = `${ESTIMATE_NAMESPACE}/REMOVE_OPERATION`;
export const REMOVE_ALL_REFERENCES = `${ESTIMATE_NAMESPACE}/REMOVE_ALL_REFERENCES`;
export const REMOVE_ALL_TIRES = `${ESTIMATE_NAMESPACE}/REMOVE_ALL_TIRES`;
export const REMOVE_ALL_LABOR_TIMES = `${ESTIMATE_NAMESPACE}/REMOVE_ALL_LABOR_TIMES`;
export const REMOVE_ALL_BUNDLES_OR_RECYCLING = `${ESTIMATE_NAMESPACE}/REMOVE_ALL_BUNDLES_OR_RECYCLING`;
export const REMOVE_ALL_OTHER_ITEMS = `${ESTIMATE_NAMESPACE}/REMOVE_ALL_OTHER_ITEMS`;
export const REMOVE_KNOWN_REFERENCE_CONFIRMATION = `${ESTIMATE_NAMESPACE}/REMOVE_KNOWN_REFERENCE_CONFIRMATION`;

export const GET_HISTORY = `${ESTIMATE_NAMESPACE}/GET_HISTORY`;
export const GET_SETTINGS = `${ESTIMATE_NAMESPACE}/GET_SETTINGS`;
export const UPDATE_SETTINGS = `${ESTIMATE_NAMESPACE}/UPDATE_SETTINGS`;
export const CREATE_ESTIMATE_FROM_DMS = `${ESTIMATE_NAMESPACE}/CREATE_ESTIMATE_FROM_DMS`;
export const SEND_ESTIMATE_TO_DMS = `${ESTIMATE_NAMESPACE}/SEND_ESTIMATE_TO_DMS`;
export const SEND_DMS_ORDER_NUMBER_REQUEST = `${ESTIMATE_NAMESPACE}/SEND_DMS_ORDER_NUMBER_REQUEST`;
export const DELETE_ESTIMATE = `${ESTIMATE_NAMESPACE}/DELETE_ESTIMATE`;
export const CANCEL_ESTIMATE_DELETION = `${ESTIMATE_NAMESPACE}/CANCEL_ESTIMATE_DELETION`;

export const FILL_FROM_MAINTENANCE_PLAN = `${ESTIMATE_NAMESPACE}/FILL_FROM_MAINTENANCE_PLAN`;
export const SEND_AUTOCOMPLETE_BUNDLES_SEARCH = `${ESTIMATE_NAMESPACE}/SEND_AUTOCOMPLETE_BUNDLES_SEARCH`;
export const SEND_AUTOCOMPLETE_REFERENCES_SEARCH = `${ESTIMATE_NAMESPACE}/SEND_AUTOCOMPLETE_REFERENCES_SEARCH`;

// B2B
export const ADD_B2B_ESTIMATE_TO_CLIENT_HISTORY = `${ESTIMATE_NAMESPACE}/ADD_B2B_ESTIMATE_TO_CLIENT_HISTORY`;
export const UPDATE_COUNTERPARTIES = `${ESTIMATE_NAMESPACE}/UPDATE_COUNTERPARTIES`;
export const CHECKOUT_B2B_ESTIMATE = `${ESTIMATE_NAMESPACE}/ORDER_FROM_ESTIMATE_B2B`;

export const EstimateIdParam = 'estimateId';
export const FocusSetting = 'focusSetting';

export interface EstimateState {
  currentEstimateId: string;
  estimates: Map<string, EstimateLocal | NO_DATA>;
  history: EstimateHistory;
  settings: Settings | NO_DATA;
  textSaveRequests: Record<string, TextSaveRequest>;
  latestTextSaveRequestByKey: Record<string, string>;
  textSaveAcknowledgements: Record<string, TextSaveAcknowledgement>;
  nonApplicableReferencesConfirmations: string[];
  estimateLogo: string | undefined;
  bundleOrRecyclingSubsectionSearch: BundleSubsectionSearch;
  freeReferenceSubsectionSearch: ReferenceSubsectionSearch;
  selectDmsOrderNumber?: SearchData<EstimateDmsOrderNumbers>;
  easyBasketEstimateCreationStatus: EasyBasketEstimateCreationStatus | undefined;
  isOrderDialogOpen: boolean;
}

export interface TextSaveRequest {
  saveKey: string;
  value: string;
}

export interface TextSaveAcknowledgement {
  requestId: string;
  value: string;
  successful: boolean;
}

export interface TextSaveStatus {
  isSaving: boolean;
  acknowledgement?: TextSaveAcknowledgement;
}

export interface EstimateOrderItemDetails {
  orderMark: string;
  mktpDeliveryMode: OrderMKTPDeliveryMode;
  referenceMarks: Map<string, string>;
  isUrgentDelivery: Map<string, boolean>;
}

export interface BundleSubsectionSearch {
  fulltextAutocomplete: MyStoreBundle[] | NO_DATA;
  lastAutocompleteKeyCode?: string;
  lastAutocompleteKeyDescription?: string;
  fulltextSearchResult?: MyStoreBundle;
}

export interface ReferenceSubsectionSearch {
  fulltextAutocomplete: MyStoreReference[] | NO_DATA;
  lastAutocompleteKeyCode?: string;
  lastAutocompleteKeyDescription?: string;
  fulltextSearchResult?: MyStoreBundle;
}

export interface EstimateOrderViewReference {
  estimateId: string;
  referenceNumber: string;
  designation: string;
  quantity: number;
  garagePrice: string;
  priceVatExcluded: string;
  hasPriceAndStock: boolean;
  isMktp?: boolean;
  sellerNumber?: string;
}

export type BundleSearchParams = {
  queryCode: string | undefined;
  queryDescription: string | undefined;
  pending: boolean;
  isValid: boolean;
  open: boolean;
  focusMenu?: number;
  searchId?: string;
};

export type ReferenceSearchParams = {
  queryReference: string | undefined;
  queryDescription: string | undefined;
  pending: boolean;
  isValid: boolean;
  open: boolean;
  focusMenu?: number;
  searchId?: string;
};

export interface EstimateHistory {
  cursor?: string;
  hasMore: boolean;
  search?: string;
  estimates: HistoryEstimateLocal[];
  searchStatus: SEARCH_STATUS;
}

export interface HistoryEstimateLocal extends HistoryEstimate {
  isHidden: boolean;
}

export interface ReferenceDiscountMargins {
  marginDiscount: number;
}

export enum EstimateType {
  B2B,
  B2C,
}

export interface EstimateLocal {
  estimateId: string;
  estimateType: EstimateType;
  creationDate: string;
  sequenceNumber?: string;
  clientContact: ClientContact;
  totalPrice: TotalPrice;
  vehicle?: EstimateVehicle;
  observations?: string;
  dmsOrderNumber?: string;
  referenceSubsection: ReferenceSection;
  laborTimeSubsection: LaborTimeSection;
  bundleOrRecyclingSubsection: BundleOrRecyclingSection;
  operationSection: OperationSection;
  totalMargin: string;
  totalMarginPercentage: string;
  referenceDiscountMarginMap: Map<string, ReferenceDiscountMargins>;
  isHidden: boolean;
  dmsExportTime: string | undefined;
  estimateOrderItemDetails: EstimateOrderItemDetails;
  estimateOrderStatus: SEARCH_STATUS;
  prices: Map<string, SearchData<ReferencePriceType>>; // Map<referenceNumber, object>
  stockInfo: Map<string, SearchData<Map<string, ReferenceStock>>>; // Map<referenceNumber, Map<seller, object>>
  referenceDiscounts: Map<string, ReferenceDiscount>; // Map<referenceNumber, object>
}

export interface RequestReference extends Omit<Reference, 'linkedReferences'> {
  linkedReferences?: LinkedReference[];
}

export interface EstimateVehicle extends Vehicle {
  dialogAddToEstimateWasShown?: boolean;
}

export const NORMAL = 'NORMAL';
export const HIGH = 'HIGH';
export const VERY_HIGH = 'VERY_HIGH';

export const MECHANICS = 'MECHANICS';
export const PAINTING = 'PAINTING';
export const PANELWORK = 'PANELWORK';
export const ELECTRICITY = 'ELECTRICITY';
export const TRIM = 'TRIM';

export interface EasyBasketEstimateCreationStatus {
  estimateId: string;
  status: PROGRESS_STATUS;
}
